
    <h1 mat-dialog-title>
      <!--<i class="fas fa-exclamation-triangle mr-3"></i>-->
      Site approval
    </h1>
    <div mat-dialog-content>
      <mat-list class="mat-dialog-data-list">
        <h3 mat-subheader>You are about to APPROVE this site(s):</h3>
        <strong></strong>
        <mat-list-item>
          <div class="d-flex flex-column">
            <strong *ngFor="let d of domains">{{d.id.url}}</strong>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end">
      <button mat-button color="warn" mat-dialog-close cdkFocusInitial>Cancel</button>
	    <button mat-button color="primary" (click)="approve()">Approve</button> 
    </div>
  